import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=ddb2b85a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddb2b85a')) {
      api.createRecord('ddb2b85a', component.options)
    } else {
      api.reload('ddb2b85a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=ddb2b85a&", function () {
      api.rerender('ddb2b85a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4VmCIFTXbWP4C/JS/comp/ErrorMessage.vue"
export default component.exports